import { Button, Typography } from "@mui/material";
import React from "react";
import ArrowAnimation from "datalign-module-template/components/arrow-animation";
import CollapseButton from "../collapse-button";

const FieldLabel = ({
  collapsible,
  label,
  collapse,
  HandleCollapse,
}: {
  collapsible: string | undefined;
  label: string | undefined;
  collapse: boolean;
  HandleCollapse: (collapse: boolean) => void;
}) => {
  return label ? (
    ["collapsed", "collapsible"].includes(collapsible ?? "") ? (
      <CollapseButton
        label={label}
        isOpen={collapse}
        HandleCollapse={HandleCollapse}
      />
    ) : (
      label && (
        <Typography variant="subtitle2" textAlign="left" fontWeight="bold">
          {label}:
        </Typography>
      )
    )
  ) : (
    <></>
  );
};

export default FieldLabel;
